import React from "react";

const ConnectIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-labelledby="asslfs6wboe6yd0ii40ao6yqmj59gqbq"
      className="fill-current text-white opacity-75 hover:text-white mx-3"
    >
      <title id="asslfs6wboe6yd0ii40ao6yqmj59gqbq">Connect</title>
      <path d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10H2l2.929-2.929A9.969 9.969 0 012 12zm4.828 8H12a8 8 0 10-8-8c0 2.152.851 4.165 2.343 5.657l1.414 1.414-.929.929zM8 13h8a4 4 0 11-8 0z"></path>
    </svg>
  );
};

export default ConnectIcon;
